import { EntityActionConfirmDialogProps } from '../../../entity-actions/interfaces/entity-actions';
import { ObjectConfig, ObjectConfigAction } from '../interfaces/object';
import { PipelineStrings } from '../../strings';
import { ObjectsConfigAPI } from '../../api/ObjectsConfigAPI';

export const getObjectConfigActionsConfirmDialogProps = (pipelineId: number) => {
  const props: EntityActionConfirmDialogProps<ObjectConfigAction, ObjectConfig> = {
    [ObjectConfigAction.VIEW_CONFIG]: {},
    [ObjectConfigAction.EDIT_CONFIG]: {},
    [ObjectConfigAction.TRUNCATE_AND_LOAD]: {
      title: 'Resync Object?',
      body: PipelineStrings.restartObjectConfirmationMessage,
      positiveButtonText: 'Resync',
      negativeButtonText: 'Cancel',
      positiveBtnProps: {
        icon: 'syncing'
      },
      successMessage: PipelineStrings.resyncObjectSuccessMessage,
      actionHandler: args => ObjectsConfigAPI.restartObject(args.entity.id, pipelineId)
    }
  };

  return props;
};
